module.exports = __webpack_public_path__ + "img/img_12.dc99bf9b.png";